"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.NoteForm = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
var _ui = require("@unite-us/ui");
var _validations = require("../utils/validations/validations");
var _components = require("./components");
var _getCollectionFromNoteType = _interopRequireDefault(require("./utils/getCollectionFromNoteType"));
var _constants = require("./utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var INTERACTION = _constants.NOTE_TYPE_VALUES.INTERACTION,
  PROVIDED_SERVICE = _constants.NOTE_TYPE_VALUES.PROVIDED_SERVICE;
var DURATION = "".concat(INTERACTION, ".duration");
var NOTE_FORM = 'note';
var NoteForm = exports.NoteForm = /*#__PURE__*/function (_Component) {
  _inherits(NoteForm, _Component);
  var _super = _createSuper(NoteForm);
  function NoteForm(props) {
    var _this;
    _classCallCheck(this, NoteForm);
    _this = _super.call(this, props);
    _this.clearFields = _this.clearFields.bind(_assertThisInitialized(_this));
    _this.handleDurationChange = _this.handleDurationChange.bind(_assertThisInitialized(_this));
    _this.handleInteractionTypeChange = _this.handleInteractionTypeChange.bind(_assertThisInitialized(_this));
    _this.handleNoteChange = _this.handleNoteChange.bind(_assertThisInitialized(_this));
    _this.handleNoteTypeChange = _this.handleNoteTypeChange.bind(_assertThisInitialized(_this));
    _this.onCancel = _this.onCancel.bind(_assertThisInitialized(_this));
    _this.onSubmit = _this.onSubmit.bind(_assertThisInitialized(_this));
    _this.resetForm = _this.resetForm.bind(_assertThisInitialized(_this));
    _this.validations = [function (value) {
      return (0, _validations.isRequired)(value);
    }];
    _this.initialState = {
      duration: null,
      interactionType: _constants.DEFAULT_INTERACTION_TYPE,
      noteType: _constants.DEFAULT_NOTE_TYPE
    };
    _this.state = _this.initialState;
    return _this;
  }
  _createClass(NoteForm, [{
    key: "onSubmit",
    value: function onSubmit(values) {
      var _this2 = this;
      var noteType = this.state.noteType;
      var collection = (0, _getCollectionFromNoteType["default"])(noteType, values);
      return Promise.resolve(this.props.onSubmit(collection)).then(function (result) {
        if (!(0, _lodash.isError)(result)) {
          _this2.resetForm();
        }
      });
    }
  }, {
    key: "onCancel",
    value: function onCancel() {
      this.resetForm();
      this.props.onCancel();
    }
  }, {
    key: "resetForm",
    value: function resetForm() {
      this.props.initialize(this.props.initialValues);
      this.setState(this.initialState);
    }
  }, {
    key: "clearFields",
    value: function clearFields() {
      var _this$props;
      for (var _len = arguments.length, fields = new Array(_len), _key = 0; _key < _len; _key++) {
        fields[_key] = arguments[_key];
      }
      (_this$props = this.props).clearFields.apply(_this$props, [NOTE_FORM, false, false].concat(fields));
    }
  }, {
    key: "handleDurationChange",
    value: function handleDurationChange(e, duration) {
      this.setState({
        duration: duration
      });
      this.props.change(DURATION, duration);
    }
  }, {
    key: "handleInteractionTypeChange",
    value: function handleInteractionTypeChange(e) {
      var interactionType = e.target.value;
      var email = _constants.INTERACTION_TYPE_VALUES.EMAIL;
      this.setState({
        interactionType: interactionType
      });
      if (interactionType === email) {
        this.clearFields(DURATION);
      } else {
        this.props.change(DURATION, this.state.duration);
      }
    }
  }, {
    key: "handleNoteChange",
    value: function handleNoteChange(e, note) {
      var noteType = this.state.noteType;
      this.props.change("".concat(noteType, ".note"), note);
    }
  }, {
    key: "handleNoteTypeChange",
    value: function handleNoteTypeChange(e) {
      var durationOptions = this.props.durationOptions;
      var noteType = e.target.value;
      this.setState({
        noteType: noteType
      });
      if (noteType === INTERACTION) {
        this.setState({
          duration: this.state.duration || (0, _lodash.head)(durationOptions).value
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        change = _this$props2.change,
        className = _this$props2.className,
        durationOptions = _this$props2.durationOptions,
        handleSubmit = _this$props2.handleSubmit,
        id = _this$props2.id,
        note = _this$props2.note,
        style = _this$props2.style,
        submitting = _this$props2.submitting,
        unitOptions = _this$props2.unitOptions;
      var _this$state = this.state,
        duration = _this$state.duration,
        interactionType = _this$state.interactionType,
        noteType = _this$state.noteType;
      var noteTypeOptions = this.props.hideServiceProvidedField ? (0, _lodash.reject)(_constants.NOTE_TYPE_OPTIONS, ['value', PROVIDED_SERVICE]) : _constants.NOTE_TYPE_OPTIONS;
      var noteFormClass = function noteFormClass() {
        return (0, _classnames["default"])('ui-note-form', className);
      };
      return /*#__PURE__*/_react["default"].createElement("form", {
        className: noteFormClass(),
        id: id,
        onSubmit: handleSubmit(this.onSubmit),
        style: style
      }, /*#__PURE__*/_react["default"].createElement(_reduxForm.FormSection, {
        name: "note"
      }, /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, {
        className: "ui-note-form__note-field",
        component: _ui.TextField,
        hideLabel: true,
        id: "ui-note-form-note-field",
        label: "Note",
        name: "note",
        onChange: this.handleNoteChange,
        placeholder: _constants.PLACEHOLDER_TEXT,
        required: true,
        rows: 10,
        validate: this.validations
      })), /*#__PURE__*/_react["default"].createElement(_ui.RadioField, {
        className: "ui-note-form__note-type-field",
        id: "ui-note-form-note-type-field",
        inline: true,
        label: "Note Type",
        onChange: this.handleNoteTypeChange,
        options: noteTypeOptions,
        value: noteType
      }), noteType === INTERACTION && /*#__PURE__*/_react["default"].createElement(_components.InteractionTypeField, {
        change: change,
        duration: duration,
        durationOptions: durationOptions,
        handleDurationChange: this.handleDurationChange,
        handleInteractionTypeChange: this.handleInteractionTypeChange,
        interactionType: interactionType,
        note: note,
        validations: this.validations
      }), noteType === PROVIDED_SERVICE && /*#__PURE__*/_react["default"].createElement(_components.ServiceProvidedField, {
        change: change,
        note: note,
        unitOptions: unitOptions,
        validations: this.validations
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "ui-note-form__action-btns"
      }, /*#__PURE__*/_react["default"].createElement(_ui.Button, {
        className: "ui-note-form__cancel-btn mr-one mr-half",
        label: "Cancel",
        onClick: this.onCancel,
        secondary: true
      }), /*#__PURE__*/_react["default"].createElement(_ui.Button, {
        className: "ui-note-form__add-note-btn",
        disabled: submitting,
        label: "Add Note",
        primary: true,
        type: "submit"
      })));
    }
  }]);
  return NoteForm;
}(_react.Component);
NoteForm.propTypes = {
  /** component props */
  /** class name */
  className: _propTypes["default"].string,
  /** id */
  id: _propTypes["default"].string,
  /** array of duration objects (i.e. `[{ display_name: '15m', value: '15' }]`) */
  durationOptions: _propTypes["default"].array.isRequired,
  /** hide the `Service Provided` option */
  hideServiceProvidedField: _propTypes["default"].bool,
  /** called when cancel button is clicked */
  onCancel: _propTypes["default"].func,
  /** called when submitting note form */
  onSubmit: _propTypes["default"].func.isRequired,
  /** override the inline styles of the NoteForm || **Not Recommended** */
  style: _propTypes["default"].object,
  /** list of options to populate `Unit` field in `ServiceProvidedField` */
  unitOptions: _propTypes["default"].array,
  /** redux form props */
  /** @ignore redux form this.props.change function */
  change: _propTypes["default"].func.isRequired,
  /**
   * @ignore
   * redux form clearFields function
   * clears values for all fields passed
   * @param {string} form name of form
   * @param {boolean} keepTouched
   * @param {boolean} persistentSubmitErrors
   * @param {string} fields one or more string fieldNames
  */
  clearFields: _propTypes["default"].func.isRequired,
  /** @ignore redux form handleSubmit function */
  handleSubmit: _propTypes["default"].func.isRequired,
  /** @ignore redux form initialize function */
  initialize: _propTypes["default"].func.isRequired,
  /** @ignore default values for note form */
  initialValues: _propTypes["default"].object.isRequired,
  /** @ignore redux form value for note field */
  note: _propTypes["default"].string,
  /** @ignore redux form submitting bool */
  submitting: _propTypes["default"].bool.isRequired
};
NoteForm.defaultProps = {
  className: '',
  hideServiceProvidedField: false,
  id: '',
  note: '',
  onCancel: _lodash.noop,
  style: {},
  unitOptions: _constants.UNIT_OPTIONS
};
var selector = (0, _reduxForm.formValueSelector)(NOTE_FORM);
var initialValues = {
  note: {
    occurred_on: _constants.TODAY,
    type: _constants.DEFAULT_NOTE_TYPE
  },
  interaction: {
    attached_to: _constants.DEFAULT_ATTACHED_TO,
    occurred_on: _constants.TODAY,
    type: _constants.INTERACTION_TYPE_VALUES.PHONE
  }
};
var _default = exports["default"] = (0, _reduxForm.reduxForm)({
  form: NOTE_FORM,
  initialValues: initialValues
})((0, _reactRedux.connect)(function (state) {
  return {
    note: selector(state, 'note.note')
  };
})(NoteForm));